import {Component, EventEmitter, inject, Output} from '@angular/core';
import {FormControl, Validators} from "@angular/forms";
import {CanvasPageInteractionsService} from "../../../../../../services/canvas-page-interactions.service";

@Component({
    selector: 'db-add-page-tooltip',
    templateUrl: './add-page-tooltip.component.html',
    styleUrl: './add-page-tooltip.component.scss',
    standalone: false
})
export class AddPageTooltipComponent {
  @Output() addPage: EventEmitter<string> = new EventEmitter<string>();
  @Output() close: EventEmitter<void> = new EventEmitter<void>();
  private _pageInteractionsService: CanvasPageInteractionsService = inject(CanvasPageInteractionsService);
  nameControl = new FormControl('', [Validators.required]);

  proceed(name: string) {
    this._pageInteractionsService.newPageTitle.next(name);
    this.close.emit();
  }
}
